import Form, { IForm } from './Form'
import loginMandatoryFieldsSet from '@/config/loginRegisterLegacy/login_form_mandatory.config'

export interface ILoginForm extends IForm {
  email: string
  password?: string

  getIsFormValid(): boolean
}

export default class LoginForm extends Form implements ILoginForm {
  public email: string
  public password?: string

  constructor(email: string, password?: string) {
    super()
    this.email = email
    this.password = password
  }

  public getIsFormValid(): boolean {
    if (loginMandatoryFieldsSet.has('email') && !this.email) return false
    if (loginMandatoryFieldsSet.has('password') && !this.password) return false

    return true
  }
}
